<template>
  <div class="staffHistory">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <van-tabs v-model="activeName" @click="onTabClick">
      <van-tab
        v-for="(v, i) in tabList"
        :key="i"
        :title="v.tabTitle"
        :name="v.tabName"
      >
        <history-component
          :active-name="v.tabName"
        />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import config from '@/common/config';
import historyComponent from './historyComponent';
export default {
  name: 'StaffMeetingHistory',
  components: {
    historyComponent
  },
  data() {
    return {
      baseURL:
        process.env.NODE_ENV === 'development'
          ? config.baseUrl.dev
          : config.baseUrl.pro,
      showQrCodeDialog: false,
      showInviteCodeDialog: false,
      inviteCode: '', // 邀请码
      hisId: '', // 历史记录id
      tabList: [
        {
          tabTitle: '我发起',
          tabName: 'MY_CREATE'
        },
        {
          tabTitle: '我审核',
          tabName: 'MY_AUDIT'
        },
        {
          tabTitle: '我参与',
          tabName: 'MY_ATTEND'
        }
      ],
      subHead: '会议记录',
      activeName: 'MY_CREATE',
      size: 10,
      visiDate: '',
      nowStatus: '', // 状态。从消息进来根据状态判断是二维码还是详情
      qrcode: '', // 因为路由参数的qrcode带#h号，被干掉了，所以从详情拿qrcode
      // historyDetail: {},
      timestamp: new Date().getTime(),
      qrCodeImgUrl: ''
    };
  },
  watch: {
    // historyDetail: {
    //   deep: true,
    //   handler(val) {
    //     this.$nextTick(() => {
    //       if (this.nowStatus === 'WAITING_VISIT') {
    //         this.showQrCodeDialog = true;
    //         this.$nextTick(() => {
    //           this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(this.qrcode)}&timestamp=${this.timestamp}`;
    //         });
    //       } else {
    //         this.$router.push({
    //           name: 'historyDetail',
    //           query: { id: this.hisId, activeName: 'MY_ATTEND' }
    //         });
    //       }
    //     });
    //   }
    // }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'bookSuccess') {
        vm.activeName = 'MY_CREATE';
      }
    });
  },
  created() {
    const personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
    if (!personalInfo.staff) {
      this.tabList = [
        {
          tabTitle: '我参与',
          tabName: 'MY_ATTEND'
        }
      ];
    }
  },
  methods: {
    goBack() {
      // this.$router.go(-1)
      this.$router.push({ name: 'user' });
    },
    // 点击tab切换
    onTabClick(name) {}
  }
};
</script>

<style lang="less" scoped>
.staffHistory {
  /deep/.van-tabs,
  .van-tabs__wrap {
    height: 0.47rem;
    .van-tabs__nav {
      background: rgba(250, 250, 250, 1);
    }
    .van-tabs__nav--line {
      color: #3b86ff;
    }
    .van-tab {
      color: #333;
    }
    .van-tab--active {
      color: #3b86ff;
    }
    .van-tabs__line {
      background-color: #3b86ff;
    }
  }
  .qrcode {
    // width: 1.64rem;
    // height: 1.64rem;
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    /deep/img {
      width: 100%;
      height: 100%;
      // height: 1.64rem;
    }
  }
  .diaCode {
    color: #333;
    text-align: center;
    font-size: 0.3rem;
    line-height: 0.3rem;
    height: 0.3rem;
    margin-bottom: 0.2rem;
  }
  .van-button {
    display: flex;
    width: 0.95rem;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center;
    margin: 0.25rem auto;
  }
  .tips {
    font-size: 0.12rem;
    color: #ffbe00;
    line-height: 0.18rem;
  }
}
</style>
